// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import classNames from 'classnames';
import { isEmpty } from 'lodash/fp';

// Utils
import contentSearch from '../../../../components/search/contentSearch/contentSearch';

// Selectors
import { createShallowSelector } from '../../../../utils/milanoteReselect/milanoteReselect';
import { getAllComments } from '../../../../element/comment/store/commentsSelector';
import { getElementFilterQuerySelector } from '../../../../element/elementFilter/elementFilterSelector';
import { getQuickNotesElementsDeep } from './quickNotesElementsSelector';

// Styles
import './QuickNotesCount.scss';

const QuickNotesContentCount = ({ className, count }) => (
    <span className={classNames('QuickNotesContentCount', className)}>{count}</span>
);

/**
 * This is the same as the 'quickNotesContentSearchSelector' in the elementSearchPopupSelector.js, however this uses
 * the submitted query.
 */
const quickNotesSubmittedContentSearchSelector = createShallowSelector(
    getQuickNotesElementsDeep,
    getElementFilterQuerySelector,
    getAllComments,
    (quickNotesElements, query, comments) =>
        contentSearch({
            query,
            elements: quickNotesElements,
            comments,
        }),
);

const mapStateToProps = createSelector(quickNotesSubmittedContentSearchSelector, (results) => ({
    searchCount: (results && results.length) || 0,
}));

let QuickNotesSearchCount = ({ searchCount = 5, count }) => (
    <QuickNotesContentCount className={classNames({ search: searchCount })} count={searchCount || count} />
);
QuickNotesSearchCount = connect(mapStateToProps)(QuickNotesSearchCount);

/**
 * This component is used so the more expensive quick notes search selector is only mounted when necessary.
 */
const QuickNotesCount = (props) => {
    const { query } = props;

    return isEmpty(query) ? <QuickNotesContentCount {...props} /> : <QuickNotesSearchCount {...props} />;
};

QuickNotesContentCount.propTypes =
    QuickNotesSearchCount.propTypes =
    QuickNotesCount.propTypes =
        {
            query: PropTypes.string,
            count: PropTypes.number,
            searchCount: PropTypes.number,
        };

export default QuickNotesCount;
